import { useState } from 'react';

function PromptsTab({ 
  pins, 
  statusFilter, 
  setStatusFilter,
  currentPinsPage,
  setCurrentPinsPage,
  totalPinsPages,
  selectedPins,
  setSelectedPins,
  approvePin,
  rejectPin,
  deletePin,
  bulkApprove,
  bulkReject
}) {
  const [searchPins, setSearchPins] = useState('');

  const toggleSelectAll = () => {
    const checkboxes = document.querySelectorAll('.pin-checkbox');
    const selectAll = document.getElementById('selectAll').checked;
    const newSelected = new Set();
    checkboxes.forEach(cb => {
      cb.checked = selectAll;
      if (selectAll) newSelected.add(cb.dataset.id);
    });
    setSelectedPins(newSelected);
  };

  const updateBulkButtons = (pinId, checked) => {
    const newSelected = new Set(selectedPins);
    if (checked) {
      newSelected.add(pinId);
    } else {
      newSelected.delete(pinId);
    }
    setSelectedPins(newSelected);
  };

  const filteredPins = pins.filter(p => 
    !searchPins || 
    p.title?.toLowerCase().includes(searchPins.toLowerCase()) || 
    p.prompt.toLowerCase().includes(searchPins.toLowerCase())
  );

  return (
    <div className="p-6">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-4">
        <h2 className="text-xl font-bold">Quản lý Prompts</h2>
        <div className="flex flex-wrap items-center gap-3">
          {selectedPins.size > 0 && (
            <>
              <button 
                onClick={bulkApprove} 
                className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 text-sm font-semibold"
              >
                <span className="material-symbols-rounded text-[18px] align-middle mr-1">check_circle</span>
                Duyệt đã chọn ({selectedPins.size})
              </button>
              <button 
                onClick={bulkReject} 
                className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 text-sm font-semibold"
              >
                <span className="material-symbols-rounded text-[18px] align-middle mr-1">cancel</span>
                Từ chối đã chọn ({selectedPins.size})
              </button>
            </>
          )}
          <select 
            value={statusFilter} 
            onChange={(e) => { setStatusFilter(e.target.value); setCurrentPinsPage(1); }} 
            className="px-4 py-2 border rounded-lg focus:outline-none focus:border-blue-500"
          >
            <option value="">Tất cả</option>
            <option value="pending">Chờ duyệt</option>
            <option value="approved">Đã duyệt</option>
            <option value="rejected">Đã từ chối</option>
          </select>
          <input 
            type="text" 
            value={searchPins} 
            onChange={(e) => setSearchPins(e.target.value)} 
            placeholder="Tìm prompt..." 
            className="px-4 py-2 border rounded-lg focus:outline-none focus:border-blue-500" 
          />
        </div>
      </div>
      
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50 border-b">
            <tr>
              <th className="px-4 py-3 text-left">
                <input 
                  type="checkbox" 
                  id="selectAll" 
                  onChange={toggleSelectAll} 
                  className="w-4 h-4 rounded border-gray-300" 
                />
              </th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Image</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Title & Board</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Tags</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">User</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Status</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Stats</th>
              <th className="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y">
            {filteredPins.map(pin => (
              <tr key={pin._id} className="hover:bg-gray-50">
                <td className="px-4 py-3">
                  <input 
                    type="checkbox" 
                    className="pin-checkbox w-4 h-4 rounded border-gray-300" 
                    data-id={pin._id} 
                    checked={selectedPins.has(pin._id)} 
                    onChange={(e) => updateBulkButtons(pin._id, e.target.checked)} 
                  />
                </td>
                <td className="px-4 py-3">
                  <img src={pin.image} className="w-16 h-16 rounded-lg object-cover" alt="" />
                </td>
                <td className="px-4 py-3">
                  <p className="font-semibold line-clamp-1">{pin.title || 'Untitled'}</p>
                  <p className="text-sm text-gray-500 line-clamp-1">{pin.prompt}</p>
                  {pin.board && (
                    <div className="flex items-center gap-1 mt-1 text-xs text-gray-600">
                      <span className="material-symbols-rounded text-[14px]">
                        {pin.board.icon || 'folder'}
                      </span>
                      <span>{pin.board.name}</span>
                    </div>
                  )}
                  {pin.status === 'rejected' && pin.rejectionReason && (
                    <p className="text-xs text-red-600 mt-1">Lý do: {pin.rejectionReason}</p>
                  )}
                </td>
                <td className="px-4 py-3">
                  {pin.tags && pin.tags.length > 0 ? (
                    <div className="flex flex-wrap gap-1 max-w-[200px]">
                      {pin.tags.slice(0, 3).map((tag, idx) => (
                        <span 
                          key={idx}
                          className="px-2 py-0.5 bg-blue-100 text-blue-700 rounded-full text-xs font-medium"
                        >
                          #{tag}
                        </span>
                      ))}
                      {pin.tags.length > 3 && (
                        <span className="text-xs text-gray-500">+{pin.tags.length - 3}</span>
                      )}
                    </div>
                  ) : (
                    <span className="text-xs text-gray-400">No tags</span>
                  )}
                </td>
                <td className="px-4 py-3 text-sm">{pin.user}</td>
                <td className="px-4 py-3">
                  <span className={`px-2 py-1 text-xs font-semibold rounded-full ${
                    pin.status === 'pending' ? 'bg-orange-100 text-orange-800' :
                    pin.status === 'approved' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                  }`}>
                    {pin.status === 'pending' ? 'Chờ duyệt' : pin.status === 'approved' ? 'Đã duyệt' : 'Đã từ chối'}
                  </span>
                </td>
                <td className="px-4 py-3">
                  <div className="space-y-1 text-xs">
                    <div className="flex items-center gap-1 text-gray-600">
                      <span className="material-symbols-rounded text-[14px]">visibility</span>
                      <span>{pin.views || 0}</span>
                    </div>
                    <div className="flex items-center gap-1 text-gray-600">
                      <span className="material-symbols-rounded text-[14px]">favorite</span>
                      <span>{pin.likes || 0}</span>
                    </div>
                    <div className="flex items-center gap-1 text-gray-600">
                      <span className="material-symbols-rounded text-[14px]">content_copy</span>
                      <span>{pin.copies || 0}</span>
                    </div>
                  </div>
                </td>
                <td className="px-4 py-3 text-right">
                  <div className="flex items-center justify-end gap-2">
                    {pin.status === 'pending' && (
                      <>
                        <button 
                          onClick={() => approvePin(pin._id)} 
                          className="px-3 py-1 text-xs font-semibold text-green-600 hover:bg-green-50 rounded-lg transition-colors"
                        >
                          Duyệt
                        </button>
                        <button 
                          onClick={() => rejectPin(pin._id)} 
                          className="px-3 py-1 text-xs font-semibold text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                        >
                          Từ chối
                        </button>
                      </>
                    )}
                    {pin.status === 'rejected' && (
                      <button 
                        onClick={() => approvePin(pin._id)} 
                        className="px-3 py-1 text-xs font-semibold text-green-600 hover:bg-green-50 rounded-lg transition-colors"
                      >
                        Duyệt lại
                      </button>
                    )}
                    <button 
                      onClick={() => deletePin(pin._id)} 
                      className="px-3 py-1 text-xs font-semibold text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                    >
                      Xóa
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {totalPinsPages > 1 && (
        <div className="flex items-center justify-between mt-6">
          <div className="text-sm text-gray-600">
            Trang {currentPinsPage} / {totalPinsPages}
          </div>
          <div className="flex gap-2">
            <button 
              onClick={() => setCurrentPinsPage(p => Math.max(1, p - 1))} 
              disabled={currentPinsPage === 1}
              className="px-4 py-2 border rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Trước
            </button>
            <button 
              onClick={() => setCurrentPinsPage(p => Math.min(totalPinsPages, p + 1))} 
              disabled={currentPinsPage === totalPinsPages}
              className="px-4 py-2 border rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Sau
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default PromptsTab;
